import styled from 'styled-components/macro';

interface Props {
    color?: string;
}

export default function LoadingSpinner(props: Props) {
    let color = props.color ? props.color : 'blue';
    return (
        <LoadingAnim viewBox="0 0 50 50" className="loading-anim">
            <Circle cx="25" cy="25" r="20" fill="none" strokeWidth="5" color={color}></Circle>
        </LoadingAnim>
    );
}

const LoadingAnim = styled.svg`
    animation: rotate 2s linear infinite;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%)
    width: 30px;
    height: 30px;
`;

const Circle = styled.circle<Props>`
    stroke: var(--color-${props => props.color});
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
`;
